import { FixtureBase, Participant } from '@cds/betting-offer';

import { IBetslipV2HorseRacePickFixture, IBetslipV2PickFixture } from '../../../core/picks/pick-models';
import { createSignedName } from '../../../core/picks/signed-name.model';
import { getEventParticipants } from './factory.helper';

export default class V2PickFactory {
    mapFixture(fixture: FixtureBase & { participants?: Participant[] }): IBetslipV2PickFixture {
        const f: IBetslipV2PickFixture = {
            fixtureId: fixture.id,
            sportId: fixture.sport.id,
            sportName: createSignedName(fixture.sport.name),
            competitionGroupId: fixture.group?.id,
            fixtureType: fixture.fixtureType,
            stage: fixture.stage,
            name: createSignedName(fixture.name),
            eventDate: new Date(fixture.startDate),
            cutOffDate: new Date(fixture.cutOffDate),
            virtual: fixture.isVirtual,
            participants: getEventParticipants(fixture),
            viewType: fixture.viewType,
            league: fixture.competition
                ? {
                      id: fixture.competition.id,
                      name: createSignedName(fixture.competition.name),
                  }
                : null,
            region: fixture.region
                ? {
                      id: fixture.region.id,
                      name: createSignedName(fixture.region.name),
                  }
                : null,
            linkedEventIds: fixture.linkedTv1EventIds,
        };

        return f;
    }

    protected mapHorseFixture(fixture: FixtureBase): IBetslipV2HorseRacePickFixture {
        return {
            ...this.mapFixture(fixture),
            bestOddsGuarantee: !!fixture.addons.bestOddsGuarantee,
            isRaceOff: !!fixture.addons.isRaceOff,
            league: fixture.meeting
                ? {
                      id: fixture.meeting.id,
                      name: createSignedName(fixture.meeting.name),
                  }
                : null,
        };
    }
}
